import { render, staticRenderFns } from "./CustomFieldEditor.vue?vue&type=template&id=61589806&"
import script from "./CustomFieldEditor.vue?vue&type=script&lang=ts&"
export * from "./CustomFieldEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports